import React from 'react';

export const FeeSettings = ({ formData, handleChange, classes }) => {
    // استخراج المستويات الفريدة من الفصول وترتيبها
    const uniqueLevels = [...new Set(classes.map(c => c.level))].sort((a, b) => {
        // ترتيب خاص للمستويات
        const order = {
            'التحضيري': 0,
            'الأول': 1,
            'الثاني': 2,
            'الثالث': 3,
            'الرابع': 4,
            'الخامس': 5,
            'السادس': 6
        };
        return (order[a] ?? 999) - (order[b] ?? 999);
    });

    return (
        <div className="p-6 border rounded-xl bg-gray-50 space-y-4">
            <h4 className="font-bold text-lg text-gray-700 mb-4">إعدادات الرسوم المالية</h4>
            
            <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">يوم تحصيل الرسوم الشهرية</label>
                <select
                    name="feeGenerationDay"
                    value={formData.feeGenerationDay || 1}
                    onChange={handleChange}
                    className="p-2 border rounded-lg w-full"
                >
                    {[...Array(28)].map((_, i) => (
                        <option key={i + 1} value={i + 1}>{i + 1}</option>
                    ))}
                </select>
                <p className="text-sm text-gray-500 mt-1">سيتم إنشاء الرسوم تلقائياً في هذا اليوم من كل شهر</p>
            </div>

            <div className="space-y-4">
                <label className="block text-sm font-medium text-gray-600">الرسوم حسب المستوى</label>
                {uniqueLevels.length > 0 ? (
                    uniqueLevels.map((level) => (
                        <div key={level} className="flex items-center gap-4">
                            <span className="text-sm text-gray-600 w-24">{level}:</span>
                            <div className="flex-1">
                                <input
                                    type="number"
                                    name={`feesPerLevel.${level}`}
                                    value={formData.feesPerLevel?.[level] || ''}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        handleChange({
                                            target: {
                                                name: 'feesPerLevel',
                                                value: {
                                                    ...(formData.feesPerLevel || {}),
                                                    [level]: parseFloat(value) || 0
                                                }
                                            }
                                        });
                                    }}
                                    min="0"
                                    step="0.01"
                                    className="p-2 border rounded-lg w-full"
                                    placeholder="أدخل المبلغ..."
                                />
                            </div>
                            <span className="text-sm text-gray-600">د.ت</span>
                        </div>
                    ))
                ) : (
                    <p className="text-sm text-gray-500">لا توجد مستويات متوفرة. الرجاء إضافة الفصول أولاً.</p>
                )}
                <p className="text-sm text-gray-500">سيتم تطبيق هذه الرسوم عند إنشاء الرسوم الشهرية تلقائياً</p>
            </div>
        </div>
    );
};
